(() => {
  const selectors = {
    trigger: '[data-find-watch-trigger]',
    modal: '[data-find-watch-modal]',
    close: '[data-find-watch-close]',
    formWrapper: '[data-find-watch-form]',
    status: '[data-find-watch-status]',
    productField: '[data-find-watch-product]',
    productUrlField: '[data-find-watch-url]',
    notesField: '[data-find-watch-notes]',
    submit: '[data-find-watch-submit]',
  };

  let activeModal = null;
  let lastFocusedElement = null;

  const statusClasses = {
    success: 'find-watch-modal__status--success',
    error: 'find-watch-modal__status--error',
  };

  const parser = new DOMParser();

  function openModal(modal) {
    if (!modal) return;
    activeModal = modal;
    lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modal.classList.add('is-active');
    modal.removeAttribute('hidden');
    document.body.classList.add('find-watch-modal-open');

    const firstInput = modal.querySelector('input:not([type="hidden"]), textarea, button');
    if (firstInput && typeof firstInput.focus === 'function') {
      firstInput.focus();
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-active');
    modal.setAttribute('hidden', '');
    document.body.classList.remove('find-watch-modal-open');
    activeModal = null;
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function setStatus(statusElement, message, type) {
    if (!statusElement) return;
    statusElement.textContent = message || '';
    statusElement.classList.remove(statusClasses.success, statusClasses.error);
    if (type && statusClasses[type]) {
      statusElement.classList.add(statusClasses[type]);
    }
  }

  function handleFormSubmit(event) {
    const wrapper = event.target.closest(selectors.formWrapper);
    if (!wrapper) return;

    const form = wrapper.querySelector('form');
    if (!form) return;

    event.preventDefault();

    const modal = wrapper.closest(selectors.modal);
    const statusElement = modal ? modal.querySelector(selectors.status) : null;
    const submitButton = form.querySelector(selectors.submit);
    const productField = form.querySelector(selectors.productField);
    const productUrlField = form.querySelector(selectors.productUrlField);
    const notesField = form.querySelector(selectors.notesField);

    if (!submitButton || !notesField) return;

    setStatus(statusElement, '');
    submitButton.disabled = true;
    submitButton.classList.add('loading');

    const productTitle = wrapper.dataset.productTitle || document.title || 'Unknown product';
    const productUrl = wrapper.dataset.productUrl || window.location.href;
    const noteText = typeof notesField.value === 'string' ? notesField.value.trim() : '';

    const messageLines = [
      `Product interest: ${productTitle}`,
      `Product URL: ${productUrl}`,
    ];

    if (noteText.length) {
      messageLines.push(`Customer notes: ${noteText}`);
    }

    notesField.value = messageLines.join('\n\n');

    if (productField) {
      productField.value = productTitle;
    }
    if (productUrlField) {
      productUrlField.value = productUrl;
    }

    const formData = new FormData(form);

    fetch(form.action || '/contact', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    })
      .then((response) => response.text())
      .then((responseText) => {
        const doc = parser.parseFromString(responseText, 'text/html');
        const successNode = doc.querySelector('.form-status.form-status-list.form__message');
        const errorNode =
          doc.querySelector('.contact__field-error .form__message') ||
          doc.querySelector('.form-status.caption-large.text-body');
        const successMessage = wrapper.dataset.successMessage || "Thanks! We'll be in touch soon.";

        if (successNode) {
          setStatus(statusElement, successMessage, 'success');
          form.reset();
          if (notesField) {
            notesField.value = '';
          }
          setTimeout(() => {
            closeModal(modal);
          }, 3000);
        } else {
          const errorMessage = errorNode ? errorNode.textContent.trim() : 'Unable to submit request. Please try again.';
          setStatus(statusElement, errorMessage, 'error');
        }
      })
      .catch(() => {
        setStatus(statusElement, 'Unable to submit request. Please try again.', 'error');
      })
      .finally(() => {
        submitButton.disabled = false;
        submitButton.classList.remove('loading');
      });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(selectors.trigger);
    if (trigger) {
      const modalId = trigger.getAttribute('data-find-watch-modal');
      const modal = modalId ? document.getElementById(modalId) : null;
      openModal(modal);
      return;
    }

    const closeTarget = event.target.closest(selectors.close);
    if (closeTarget && activeModal) {
      closeModal(activeModal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeModal) {
      event.preventDefault();
      closeModal(activeModal);
    }
  });

  document.addEventListener('submit', handleFormSubmit);
})();
